export default "__VITE_ASSET__D18FtSIH__"